<script setup lang="ts">
import { useScrollLock } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import { onMounted, watch } from 'vue';

import { useOverlay } from '@/stores/overlay';

const { hide } = useOverlay();
const { scrollUnlocked, visible } = storeToRefs(useOverlay());

onMounted(() => {
  const isLocked = useScrollLock(document.querySelector('body'));

  watch(visible, (b) => {
    if (!scrollUnlocked.value) isLocked.value = b;
  });
});
</script>

<template>
  <div
    class="fixed top-0 right-0 bottom-0 left-0 bg-black/40 custom-overlay"
    :class="[visible ? 'opacity-100' : 'opacity-0 hidden']"
    @click="hide"
  />
</template>

<style scoped>
.custom-overlay {
  transition: opacity 0.4s ease;
}
</style>
